/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Current payment status of the booking
 */
export enum BookingPaymentStatus {
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PROCESSING_PAYMENT = 'PROCESSING_PAYMENT',
  PAYMENT_RECEIVED = 'PAYMENT_RECEIVED',
  FAILED = 'FAILED',
  REFUND_PENDING = 'REFUND_PENDING',
  REFUNDED = 'REFUNDED',
  REFUND_FAILED = 'REFUND_FAILED',
  EXPIRED = 'EXPIRED',
  CASH = 'CASH',
  FREE = 'FREE',
  DISPUTED = 'DISPUTED',
  PAYOUT_READY = 'PAYOUT_READY',
  PAID_OUT = 'PAID_OUT'
}
